import { createContext } from 'react';
import EditUserContext from 'types/contexts/EditUserContext';

export default createContext({} as EditUserContext);
